module.exports = __webpack_public_path__ + "img/20201217_145445.51f4f03f.jpg";